import { api, type ApiResponse } from "./client";
import type { Inbox } from "@/types/inbox";

export interface InboxStats {
  open: number;
  pending: number;
  resolved: number;
  total: number;
}

export const inboxesApi = {
  list: (params?: Record<string, string>): Promise<ApiResponse<Inbox[]>> =>
    api.get("/inboxes", params),

  get: (id: number): Promise<ApiResponse<Inbox>> => api.get(`/inboxes/${id}`),

  getStats: (): Promise<ApiResponse<InboxStats>> => api.get("/inboxes/stats"),

  create: (data: Partial<Inbox>): Promise<ApiResponse<Inbox>> =>
    api.post("/inboxes", data),

  update: (id: number, data: Partial<Inbox>): Promise<ApiResponse<Inbox>> =>
    api.put(`/inboxes/${id}`, data),

  delete: (id: number): Promise<ApiResponse<Inbox>> =>
    api.del(`/inboxes/${id}`),
};
